import center from '@turf/center'

function getCenterFromGeojson({ geojson }) {
  const centerPoint = center(geojson)

  const [longitude, latitude] = centerPoint.geometry.coordinates
  return [ longitude, latitude ]
}

export default getCenterFromGeojson



// WEBPACK FOOTER //
// ./src/utility/getCenterFromGeojson.js